import React, { useState } from "react";
import PropTypes from "prop-types";
import Select from "react-select";
import { useDispatch } from "react-redux";
import { Button, Modal } from "reactstrap";
import CustomButtom from "../../Button";
import TextInput from "../../TextInput";
import { getBulkUpdateStatuses } from "reducers/Shipments";
import { selectTheme } from "constants";
import DateInput from "components/DatePicker";

const RemarkOptions = [{
  label: "Any situation which causes a delay clearing customs",
  value: "0"
}, {
  label: "This package was delayed by a late trailer",
  value: "1"
}, {
  label: "This package was left in building - non-carrier controllable",
  value: "2"
}, {
  label: "Facility breakdown or power outage",
  value: "3"
}, {
  label: "This package was delayed by a late airplane",
  value: "4"
}, {
  label: "This package was delayed by a domestic inspection",
  value: "5"
}, {
  label: "Consignee refused to accept package",
  value: "6"
}, {
  label: "Delay in delivery due to weather, natural disaster, or unavoidable event - Force Majeure - Large Scale delay",
  value: "7"
}, {
  label: "Due to wrong details",
  value: "8"
}, {
  label: "Consignee was not reachable/available",
  value: "9"
}, {
  label: "Consignee requested future delivery",
  value: "10"
}, {
  label: "Pick up delay by supplier",
  value: "11"
}, {
  label: "Shipment delay by seller",
  value: "12"
}, {
  label: "Missed operating order",
  value: "13"
}, {
  label: "Overloaded and can't operating on time",
  value: "14"
}, {
  label: "Flight daly",
  value: "15"
}, {
  label: "Airport congestion, waiting for unloading",
  value: "16"
}, {
  label: "HK Customs clearance delay",
  value: "17"
}, {
  label: "KSA Customs clearance delay",
  value: "18"
}, {
  label: "HK&KSA Customs clearance delay",
  value: "19"
}, {
  label: "Site cargo accumulation, can not be handled in time;",
  value: "20"
}, {
  label: "Missing canning in system",
  value: "21"
}, {
  label: "Amazon late reply for the reservation",
  value: "22"
}, {
  label: "Failure Delivery to Amazon warehouse",
  value: "23"
}, {
  label: "Delays during waitting escheduling of delivery feedback by Amazon",
  value: "24"
}, {
  label: "CN holiday daly",
  value: "25"
}, {
  label: "KSA holiday daly",
  value: "26"
}, {
  label: "Hold shipment by Seller",
  value: "27"
}, {
  label: "Hold shipment by Amazon",
  value: "28"
}, {
  label: "Other",
  value: "Other"
}];

const ChangeStatusModal = ({ open, onClose, loading, onConfirm }) => {
  const dispatch = useDispatch();

  const [statusList, setStatusList] = useState([]);
  const [remark, setRemark] = useState("");
  const [status, setStatus] = useState(null);
  const [date, setDate] = useState(null);
  const [selectedRemark, setSelectedRemark] = useState("");

  /**
   * Fetch order status
   */
  const getAllOrderStatus = async () => {
    const res = await dispatch(getBulkUpdateStatuses());
    const list = res.map((option) => ({
      label: option.status,
      value: option.scanTypeId
    }));
    setStatusList(list);
  };

  React.useEffect(() => {
    getAllOrderStatus();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSelectRemark = (selectedValue) => {
    setSelectedRemark(selectedValue);
    if ("Other" === selectedValue.value) {
      setRemark("");
    } else {
      setRemark(selectedValue.label);
    }
  }

  const handleSubmit = () => {
    onConfirm(status.value, remark, date);

    setDate(null);
    setRemark("");
    setStatus(null);
    setSelectedRemark("");
  };

  return (
    <Modal
      zIndex={2000}
      centered
      isOpen={open}
      toggle={loading ? null : onClose}>
      <div className="text-center p-5">
        <div className="pt-4">
          <Select
            isSearchable
            placeholder="Select Status"
            value={status}
            onChange={setStatus}
            options={statusList}
            theme={(theme) => selectTheme(theme)}
            style={{ borderRadius: "5px", height: "48px" }}
          />
          <Select
            isSearchable
            className="mt-3"
            placeholder="Select Remark"
            value={selectedRemark}
            onChange={handleSelectRemark}
            options={RemarkOptions}
            theme={(theme) => selectTheme(theme)}
            style={{ borderRadius: "5px", height: "48px" }}
          />
          {
            "Other" === selectedRemark?.value &&
            <TextInput
              className="mt-3"
              placeholder="Enter Remark"
              onChange={(e) => setRemark(e.target.value)}
            />
          }
          <DateInput
            containerClass="mt-3 w-100"
            showTimeSelect
            date={date}
            timeIntervals={1}
            dateFormat="dd/MM/yyyy h:mm aa"
            onChange={setDate}
            placeholder={"Select Date Time"}
          />
          <Button
            onClick={loading ? null : onClose}
            color="neutral-secondary"
            className="btn-pill mx-1">
            <span className="btn-wrapper--label">Cancel</span>
          </Button>
          <CustomButtom
            onClick={handleSubmit}
            disabled={!status || !remark || loading}
            label={loading ? "Submitting..." : "Submit"}
          />
        </div>
      </div>
    </Modal>
  );
};

export default ChangeStatusModal;

ChangeStatusModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  confirmText: PropTypes.string,
  subText: PropTypes.string,
  onConfirm: PropTypes.func,
  icon: PropTypes.array
};
